import axiosInstance from './config/api';

export const PartyStages = {
    NewLead: 'New Lead',
    LostOpportunity: '$225 Lost Opportunity',
    Outreach: 'Outreach',
    ExistingCaseClient: 'Existing Case Client',
    Unqualified: 'Unqualified',
    UnableToContact: 'Unable to Contact',
    OpenConsult: 'Open Consult',
    PitchedPending: '$225 Pitched - Pending',
} as const;

export interface PartyStagesResponse {
    data: (keyof typeof PartyStages)[];
}

export const getPartyStages = () => {
    return axiosInstance.get<PartyStagesResponse>('/parties/stages').then((res) => res.data);
};
